import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { theme } from 'src/styles/theme';

import Question from "src/assets/icons/question.svg";
import Comment from "src/assets/icons/comment.svg";
import ProfileBadge from 'src/components/ProfileBadge';
import { Tooltip as ReactTooltip } from "react-tooltip";
import RIghtArrow from "src/assets/icons/double-arrow-right.svg";
import { BsIndent } from 'react-icons/bs';

interface QcastSidebarProps {
  title: string;
  videos: any[];
  videoIndex: number,
  answerCount: number;
  avatarSrc: string;
  transcription:any[];
  onSelectQcast: (index: number)=> void;
  onHidePannel: (hide: boolean)=>void;
}

interface TabProps {
  isActive: boolean;
}

const SidebarContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 480px;
  // height: 994px; //calc(100vh - 80px);
  background-color: rgba(252, 253, 254, 0.6);
  border-radius: ${theme.borderRadius.large};
  border-left: 0px solid rgba(0, 0, 0, 0.1);
  // position: fixed;
  // right: 0;
  // top: 80px;
  overflow: hidden;
  // @media (max-width: ${theme.breakpoints.desktop}px) {
  //   width: 30.96%;
  // }

  // @media (max-width: ${theme.breakpoints.mobile}px) {
  //   width: 30.96%;
  // }

  // @media (max-width: ${theme.breakpoints.tablet}px) {
  //   width: 30.96%;
  // }

  // @media (max-width: ${theme.breakpoints.maxTablet}px) {
  //   width: 30.96%;
  // }

  // @media (max-width: ${theme.breakpoints.maxDesktop}px) {
  //   width: 30.96%;
  //   position:inherit;
  // }
`;

const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  padding: 0px 24px 32px;
  overflow-y: auto;
  flex: 1;
`;

const TitleSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 16px 15px 0px;
  width: 100%;
  height: 185px;
`;

const TitleHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
`;

const HeaderRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: start;
  width: 100%;
`;

const Title = styled.h2`
  font-family: ${theme.fonts.secondary};
  font-weight: ${theme.fontWeights.bold};
  font-size: ${theme.fontSizes.xxl};
  color: ${theme.colors.black};
  letter-spacing: -0.01em;
  line-height: 120%;
  letter-spacing: -1%;

  // @media (max-width: ${theme.breakpoints.desktop}px) {
  //   font-size: calc(${theme.fontSizes.xxl} * (${theme.breakpoints.desktop} / 1920));
  // }

  // @media (max-width: ${theme.breakpoints.mobile}px) {
  //   font-size: calc(${theme.fontSizes.xxl} * (${theme.breakpoints.mobile} / 1920));
  // }

  // @media (max-width: ${theme.breakpoints.tablet}px) {
  //   font-size: calc(${theme.fontSizes.xxl} * (${theme.breakpoints.tablet} / 1920));
  // }

  // @media (max-width: ${theme.breakpoints.maxTablet}px) {
  //   font-size: calc(${theme.fontSizes.xxl} * (${theme.breakpoints.maxTablet} / 1920));
  // }

  // @media (max-width: ${theme.breakpoints.maxDesktop}px) {
  //   font-size: calc(${theme.fontSizes.xxl} * (${theme.breakpoints.maxDesktop} / 1920));
  // }
`;

const CloseButton = styled.button`
  width: 32px;
  height: 32px;
  margin:8px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`;

const StatsRow = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

const StatItem = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`;

const StatIcon = styled.div`
  width: 13px;
  height: 13px;
  display: flex;
  justify-content: center;
  align-items: center;

  &>img{
    width: 100%;
    height: 100%;
  }
`;

const StatText = styled.span`
  font-family: ${theme.fonts.primary};
  font-weight: ${theme.fontWeights.medium};
  font-size: ${theme.fontSizes.md};
  color: ${theme.colors.gray[500]};

  // @media (max-width: ${theme.breakpoints.desktop}px) {
  //   font-size: calc(${theme.fontSizes.md} * (${theme.breakpoints.desktop} / 1920));
  // }

  // @media (max-width: ${theme.breakpoints.mobile}px) {
  //   font-size: calc(${theme.fontSizes.md} * (${theme.breakpoints.mobile} / 1920));
  // }

  // @media (max-width: ${theme.breakpoints.tablet}px) {
  //   font-size: calc(${theme.fontSizes.md} * (${theme.breakpoints.tablet} / 1920));
  // }

  // @media (max-width: ${theme.breakpoints.maxTablet}px) {
  //   font-size: calc(${theme.fontSizes.md} * (${theme.breakpoints.maxTablet} / 1920));
  // }

  // @media (max-width: ${theme.breakpoints.maxDesktop}px) {
  //   font-size: calc(${theme.fontSizes.md} * (${theme.breakpoints.maxDesktop} / 1920));
  // }
`;

const TabsContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 24px;
`;

const Tab = styled.div<TabProps>`
  padding: 10px 0;
  font-family: ${theme.fonts.primary};
  font-weight: ${props => props.isActive ? theme.fontWeights.semiBold : theme.fontWeights.medium};
  font-size: ${theme.fontSizes.base};
  color: ${theme.colors.gray[700]};
  opacity: ${props => props.isActive ? 1 : 0.3};
  border-bottom: ${props => props.isActive ? `2px solid ${theme.colors.gray[700]}` : 'none'};
  cursor: pointer;

  // @media (max-width: ${theme.breakpoints.desktop}px) {
  //   font-size: calc(${theme.fontSizes.base} * (${theme.breakpoints.desktop} / 1920));
  // }

  // @media (max-width: ${theme.breakpoints.mobile}px) {
  //   font-size: calc(${theme.fontSizes.base} * (${theme.breakpoints.mobile} / 1920));
  // }

  // @media (max-width: ${theme.breakpoints.tablet}px) {
  //   font-size: calc(${theme.fontSizes.base} * (${theme.breakpoints.tablet} / 1920));
  // }

  // @media (max-width: ${theme.breakpoints.maxTablet}px) {
  //   font-size: calc(${theme.fontSizes.base} * (${theme.breakpoints.maxTablet} / 1920));
  // }

  // @media (max-width: ${theme.breakpoints.maxDesktop}px) {
  //   font-size: calc(${theme.fontSizes.base} * (${theme.breakpoints.maxDesktop} / 1920));
  // }
`;

const QuestionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  height: 414px;
  overflow: auto;
`;
const TranscriptPara = styled.p`
 color:black
`;
const TranscriptCon = styled.div`
display: flex;
    align-items: flex-start;
    width: 100%;

`;

const QuestionItem = styled.div<{ isActive?: boolean }>`
  width: 100%;
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  padding: 16px 5px;
  border-radius: ${theme.borderRadius.small};
  background-color: ${props => props.isActive ? theme.colors.gray[100] : 'transparent'};
  cursor: pointer;

  &:hover{
    background-color: ${theme.colors.gray[100]};
  }

  // @media (max-width: ${theme.breakpoints.desktop}px) {
  //   width: 100%;
  //   padding: 16px 0px;
  // }

  // @media (max-width: ${theme.breakpoints.mobile}px) {
  //   width: 100%;
  //   padding: 16px 0px;
  // }

  // @media (max-width: ${theme.breakpoints.tablet}px) {
  //   width: 100%;
  //   padding: 16px 0px;
  // }

  // @media (max-width: ${theme.breakpoints.maxTablet}px) {
  //   width: 100%;
  //   padding: 16px 0px;
  // }

  // @media (max-width: ${theme.breakpoints.maxDesktop}px) {
  //   width: 100%;
  //   padding: 16px 0px;
  // }

`;
const QuestionDetail = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  justify-content: flex-start;

  width: calc(100% - 76px);
`;

const QuestionAvater = styled.div`
  width: 52px;
  height: 52px;
  border-radius: 50%;
  // background-color: ${theme.colors.gray[200]};
  // border: 1px solid ${theme.colors.white};
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;

`;
const QuestionNumber = styled.div`
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background-color: ${theme.colors.gray[200]};
  border: 1px solid ${theme.colors.white};
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: ${theme.fonts.primary};
  font-weight: ${theme.fontWeights.bold};
  font-size: 8px;
  color: ${theme.colors.black};
  position: absolute;
  left: 62px;
  margin-top: 15px;
`;

const QuestionContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;

  
`;

const QuestionText = styled.p<{ isActive?: boolean }>`
  font-family: ${theme.fonts.primary};
  font-weight: ${props => props.isActive ? theme.fontWeights.bold : theme.fontWeights.regular};
  font-size: ${theme.fontSizes.base};
  color: ${props => props.isActive ? theme.colors.primary : theme.colors.black};
  max-width: 78%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;


  // @media (max-width: ${theme.breakpoints.desktop}px) {
  //   font-size: calc(${theme.fontSizes.base} * (${theme.breakpoints.desktop} / 1920));
  // }

  // @media (max-width: ${theme.breakpoints.mobile}px) {
  //   font-size: calc(${theme.fontSizes.base} * (${theme.breakpoints.mobile} / 1920));
  // }

  // @media (max-width: ${theme.breakpoints.tablet}px) {
  //   font-size: calc(${theme.fontSizes.base} * (${theme.breakpoints.tablet} / 1920));
  // }

  // @media (max-width: ${theme.breakpoints.maxTablet}px) {
  //   font-size: calc(${theme.fontSizes.base} * (${theme.breakpoints.maxTablet} / 1920));
  // }

  // @media (max-width: ${theme.breakpoints.maxDesktop}px) {
  //   font-size: calc(${theme.fontSizes.base} * (${theme.breakpoints.maxDesktop} / 1920));
  // }
`;

const QuestionActions = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

const ActionIcon = styled.div`
  width: 24px;
  height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4px;
  cursor: pointer;

  &>span{
    font-family: ${theme.fonts.primary};
    font-weight: ${theme.fontWeights.regular};
    font-size: ${theme.fontSizes.sm};
    line-height: 100%;
    letter-spacing: 0%;
    color: ${theme.colors.black};

    

    // @media (max-width: ${theme.breakpoints.desktop}px) {
    //   font-size: calc(${theme.fontSizes.sm} * (${theme.breakpoints.desktop} / 1920));
    // }

    // @media (max-width: ${theme.breakpoints.mobile}px) {
    //   font-size: calc(${theme.fontSizes.sm} * (${theme.breakpoints.mobile} / 1920));
    // }

    // @media (max-width: ${theme.breakpoints.tablet}px) {
    //   font-size: calc(${theme.fontSizes.sm} * (${theme.breakpoints.tablet} / 1920));
    // }

    // @media (max-width: ${theme.breakpoints.maxTablet}px) {
    //   font-size: calc(${theme.fontSizes.sm} * (${theme.breakpoints.maxTablet} / 1920));
    // }

    // @media (max-width: ${theme.breakpoints.maxDesktop}px) {
    //   font-size: calc(${theme.fontSizes.sm} * (${theme.breakpoints.maxDesktop} / 1920));
    // }
  }
`;

const SuggestionsSection = styled.div`
  display: none;
  flex-direction: column;
  align-items: center;
  gap: 32px;
  padding-top: 32px;
  width: 100%;
  border-top: 1px solid rgba(0, 0, 0, 0.1);

  
`;

const SectionTitle = styled.h3`
  font-family: ${theme.fonts.primary};
  font-weight: ${theme.fontWeights.bold};
  font-size: ${theme.fontSizes.xl};
  color: ${theme.colors.transparentBlack};
  align-self: flex-start;

  // @media (max-width: ${theme.breakpoints.desktop}px) {
  //   font-size: calc(${theme.fontSizes.xl} * (${theme.breakpoints.desktop} / 1920));
  // }

  // @media (max-width: ${theme.breakpoints.mobile}px) {
  //   font-size: calc(${theme.fontSizes.xl} * (${theme.breakpoints.mobile} / 1920));
  // }

  // @media (max-width: ${theme.breakpoints.tablet}px) {
  //   font-size: calc(${theme.fontSizes.xl} * (${theme.breakpoints.tablet} / 1920));
  // }

  // @media (max-width: ${theme.breakpoints.maxTablet}px) {
  //   font-size: calc(${theme.fontSizes.xl} * (${theme.breakpoints.maxTablet} / 1920));
  // }

  // @media (max-width: ${theme.breakpoints.maxDesktop}px) {
  //   font-size: calc(${theme.fontSizes.xl} * (${theme.breakpoints.maxDesktop} / 1920));
  // }
`;

const SuggestionsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  width: 100%;
  height: 250px;
  overflow: auto;
`;

const SuggestionItem = styled.div`
  display: flex;
  gap: 8px;
  padding-bottom: 32px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
`;

const AvatarCircle = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: #ccc;
  background-image: url('https://randomuser.me/api/portraits/men/32.jpg');
  background-size: cover;
`;

const SuggestionContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding-left: 24px;
  flex: 1;
`;

const QcasterName = styled.span`
  font-family: ${theme.fonts.primary};
  font-weight: ${theme.fontWeights.medium};
  font-size: ${theme.fontSizes.md};
  color: ${theme.colors.gray[600]};

  // @media (max-width: ${theme.breakpoints.desktop}px) {
  //   font-size: calc(${theme.fontSizes.md} * (${theme.breakpoints.desktop} / 1920));
  // }

  // @media (max-width: ${theme.breakpoints.mobile}px) {
  //   font-size: calc(${theme.fontSizes.md} * (${theme.breakpoints.mobile} / 1920));
  // }

  // @media (max-width: ${theme.breakpoints.tablet}px) {
  //   font-size: calc(${theme.fontSizes.md} * (${theme.breakpoints.tablet} / 1920));
  // }

  // @media (max-width: ${theme.breakpoints.maxTablet}px) {
  //   font-size: calc(${theme.fontSizes.md} * (${theme.breakpoints.maxTablet} / 1920));
  // }

  // @media (max-width: ${theme.breakpoints.maxDesktop}px) {
  //   font-size: calc(${theme.fontSizes.md} * (${theme.breakpoints.maxDesktop} / 1920));
  // }
`;

const QcastTitle = styled.h4`
  font-family: ${theme.fonts.primary};
  font-weight: ${theme.fontWeights.bold};
  font-size: ${theme.fontSizes.base};
  color: ${theme.colors.gray[800]};
  margin-top: 4px;

  // @media (max-width: ${theme.breakpoints.desktop}px) {
  //   font-size: calc(${theme.fontSizes.base} * (${theme.breakpoints.desktop} / 1920));
  // }

  // @media (max-width: ${theme.breakpoints.mobile}px) {
  //   font-size: calc(${theme.fontSizes.base} * (${theme.breakpoints.mobile} / 1920));
  // }

  // @media (max-width: ${theme.breakpoints.tablet}px) {
  //   font-size: calc(${theme.fontSizes.base} * (${theme.breakpoints.tablet} / 1920));
  // }

  // @media (max-width: ${theme.breakpoints.maxTablet}px) {
  //   font-size: calc(${theme.fontSizes.base} * (${theme.breakpoints.maxTablet} / 1920));
  // }

  // @media (max-width: ${theme.breakpoints.maxDesktop}px) {
  //   font-size: calc(${theme.fontSizes.base} * (${theme.breakpoints.maxDesktop} / 1920));
  // }
`;

const QcastStats = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  margin-top: 14px;
`;

const MoreButton = styled.div`
  width: 24px;
  height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`;

export const QcastSidebar: React.FC<QcastSidebarProps> = ({
  title,
  videos,
  videoIndex,
  answerCount,
  avatarSrc,
  onSelectQcast,
  onHidePannel,
  transcription
}) => {
  const [activeTab, setActiveTab] = useState<'questions' | 'transcript' | 'attachments'>('questions');
  const [activeQuestion, setActiveQuestion] = useState<number>(1);
  const [qcasts, setQcasts] = useState<any[]>([]);
  const [transcriptionData, seTranscriptionData] = useState("");
  const [hide, setHide] = useState<boolean>(false);

  const handleSelectQcast =(index: number)=>{
    setActiveQuestion(index + 1);
    onSelectQcast(index);
  }

  const handleExpandBtnClick=()=>{
    onHidePannel(!hide);
    setHide(!hide);
  }

  useEffect(()=>{
    
    if(videos && videos.length>0){
      setQcasts(videos);
    }
    
  }, [videos]);

  useEffect(()=>{
    setActiveQuestion(videoIndex + 1)
   
  }, [videoIndex])
  useEffect(()=>{
    try{
    
      seTranscriptionData(transcription.filter(v=>v.index==videoIndex)[0].transcription_text)
    }catch(err){
  seTranscriptionData("")
    }
  }, [videoIndex,transcription])
  console.log("transcription",transcription)
  console.log(videos)
  return (
    <SidebarContainer>
      <ContentContainer>
        <TitleSection>
          <TitleHeader>
            <HeaderRow>
              <Title>{title}</Title>
              <CloseButton onClick={handleExpandBtnClick}>
              <BsIndent color={theme.colors.black} size={20} />
              </CloseButton>
            </HeaderRow>
            <StatsRow>
              <StatItem>
                <StatIcon>
                  <img src={Question} />
                </StatIcon>
                <StatText>{qcasts.length} questions</StatText>
              </StatItem>
              <StatItem>
                <StatIcon>
                  <img src={Comment} />
                </StatIcon>
                <StatText>{answerCount} answers</StatText>
              </StatItem>
            </StatsRow>
          </TitleHeader>
          <TabsContainer>
            <Tab isActive={activeTab === 'questions'} onClick={() => setActiveTab('questions')}>
              Questions
            </Tab>
            <Tab isActive={activeTab === 'transcript'} onClick={() => setActiveTab('transcript')}>
              Transcript
            </Tab>
            {/* <Tab isActive={activeTab === 'attachments'} onClick={() => setActiveTab('attachments')}>
              Attachments
            </Tab> */}
          </TabsContainer>
        </TitleSection>

        {activeTab === 'questions' && (
          <QuestionsContainer>
            {Array.from({ length: qcasts.length }, (_, i) => (
              <QuestionItem 
                key={i} 
                isActive={i + 1 === activeQuestion}
                onClick={() => handleSelectQcast(i)}
              >
                <QuestionDetail>
                  <QuestionAvater>
                    <ProfileBadge
                      imageUrl={avatarSrc}
                      notificationCount={i + 1}
                    />
                  </QuestionAvater>
                  
                  <QuestionText  isActive={i + 1 === activeQuestion}>
                    {transcription?.[i]?.transcription_text||qcasts[i].question}

                  </QuestionText>  
                  <ReactTooltip
                  style={{maxWidth: 400}}
        id={`my-tooltip-${i}`}
        place="top"
        content={transcription?.[i]?.transcription_text||qcasts[i].question}
      />
                </QuestionDetail>
                
                <QuestionActions>
                  <ActionIcon>
                    <img src={Comment} />
                    <span>{qcasts[i].comment}</span>
                  </ActionIcon>
                  <ActionIcon>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="12" cy="6" r="2" fill="#000000" opacity="0.5"/>
                      <circle cx="12" cy="12" r="2" fill="#000000" opacity="0.5"/>
                      <circle cx="12" cy="18" r="2" fill="#000000" opacity="0.5"/>
                    </svg>
                  </ActionIcon>
                </QuestionActions>
              </QuestionItem>
            ))}
          </QuestionsContainer>
        )}
         {activeTab === 'transcript' && (
          <TranscriptCon>
          <TranscriptPara>
          <>
          {transcriptionData}
          </>
            
          </TranscriptPara>
          </TranscriptCon>
        )}

        {/* <SuggestionsSection>
          <SectionTitle>More like this</SectionTitle>
          <SuggestionsList>
            {Array.from({ length: 3 }, (_, i) => (
              <SuggestionItem key={i}>
                <AvatarCircle />
                <SuggestionContent>
                  <QcasterName>Name of Qcaster</QcasterName>
                  <QcastTitle>Questions for school leavers: WHAT'S NEXT?????</QcastTitle>
                  <QcastStats>
                    <StatItem>
                      <StatIcon>
                        <img src={Question} />
                      </StatIcon>
                      <StatText>12 questions</StatText>
                    </StatItem>
                    <StatItem>
                      <StatIcon>
                        <img src={Comment} />
                      </StatIcon>
                      <StatText>12 answers</StatText>
                    </StatItem>
                  </QcastStats>
                </SuggestionContent>
                <MoreButton>
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="12" cy="6" r="2" fill="#000000" opacity="0.5"/>
                    <circle cx="12" cy="12" r="2" fill="#000000" opacity="0.5"/>
                    <circle cx="12" cy="18" r="2" fill="#000000" opacity="0.5"/>
                  </svg>
                </MoreButton>
              </SuggestionItem>
            ))}
          </SuggestionsList>
        </SuggestionsSection> */}
      </ContentContainer>
    </SidebarContainer>
  );
}; 